import Result from "@/core/common/Result";

export enum AgendamentoStatusOutput {
  NaoAgendado = 1,
  Agendado = 2,
  EmConfirmacao = 3,
  Cancelado = 4
}

export type AgendamentoOutput = {
  id: string;
  status: AgendamentoStatusOutput;
  data?: string;
  tipo?: number;
};

export type ObterAgendamentosOutput = {
  agendamentos: AgendamentoOutput[];
};

export interface IObterAgendamentosUseCase {
  execute(): Promise<Result<ObterAgendamentosOutput>>;
}

export const obterAgendamentosUseCaseDI = "obterAgendamentosUseCaseDI";
